export default {
    data() {
        return {
            isSubmissionsMenuTwoHidden: true,
            isSubmissionsMenuHidden: true,
            exportableJobId: null,
            queryParams: null
        }
    },
    computed: {
        getStatus() {
            return (status) => {
                switch (status.toLowerCase()) {
                    case 'closed':
                        return 'bg-cg-red';
                    default:
                        return 'bg-primary';
                }

            }
        },
    },
    methods: {
        hideExportSubmissionsMenu(){
            this.isSubmissionsMenuTwoHidden = true;
            this.$refs.exportableSubmenuTwo.$data.isExportableMenuHidden = true;
        },
        hideSaveSubmissionsMenu() {
            this.isSubmissionsMenuHidden = true;
            this.$refs.exportableSubmenu.$data.isExportableMenuHidden = true;
        },
        hideBothSubmissionsMenu() {
            this.hideSaveSubmissionsMenu();
            this.hideExportSubmissionsMenu();
        },
        /**
         * @param {string} query
         */
        appendToQueryParams(query) {
            if (this.queryParams && this.queryParams.toString().length > 0) {
                this.queryParams += `&${query}`;
            }else {
                this.queryParams = query;
            }
        },
        /**
         * @param {array} submissions
         * @return {string}
         */
        getSubmissionsSelectedIds(submissions) {
            return submissions.reduce((acc, val, indx) => {
                acc += val.submission_id + (indx < (submissions.length-1) ? ',' : '');
                return acc;
            }, '')
        },
        /**
         * @param {string} val
         */
        exportClicked({optionSelected, type}) {
            if (optionSelected === 'selected') {
                const submissionsSelected = this.$refs.submissionsListView.$data.selected;
                if (submissionsSelected.length > 0) {
                    const submissionsIds = this.getSubmissionsSelectedIds(submissionsSelected);
                    this.appendToQueryParams(`selected=${submissionsIds}`);
                    this.exportSubmissions(type, optionSelected)
                    this.hideBothSubmissionsMenu();
                }
            }
            else if (optionSelected === 'all') {
                this.appendToQueryParams('chd=all');
                this.exportSubmissions(type, optionSelected);
                this.hideBothSubmissionsMenu();
            }
        },
        /*
         * @param {string} type
         * @param {string} selected
         */
        exportSubmissions(type, selected) {
            if (!this.exportableJobId) return;
            if (!this.$props.companyId) return;

            let url = `/download-job-submissions/${type}/${this.$props.companyId}/${this.exportableJobId}`;
            if (this.queryParams) {
                url = `${url}?${this.queryParams}`;
            }
            window.open(url);
        }
    }
}
